var BaseView = require('../../../components/accordion-list/content');
var AnalyticsDecorate = require('../../../../../analytics/decorate');

module.exports = AnalyticsDecorate(require('../../../customize/analytics/stickers'), BaseView.extend({
  apiCall: 'search/stickers',
  dataName: 'stickerCategories',
  callbackName: 'callbackAdminStickers',
  where: {},
  idPrefix: '',

  initialize: function (options) {
    this.category = { id: 0, name: 'All' };
    BaseView.prototype.initialize.call(this, options);
  },

  getScrollHeight: function ($target) {
    return $target.closest('.tool-content').height();
  },

  getParams: function () {
    var params = {
      from: this.from,
      limit: this.limit,
      where: $.extend(this.where, { active: INKIVE.C.USER.IS_SUPER ? 0 : 1 })
    };

    this.from += this.limit;

    return params;
  },

  extractData: function (data) {
    var that = this;
    return _.map(data, function (item) {
      var id = (that.idPrefix) ? that.idPrefix + '-' : '';
      id += 'sticker-' + item['id'];

      return {
        id: id,
        src: item['url'],
        width: item['width'],
        height: item['height'],
        cls: parseInt(item['active']) ? '' : ' grayscale',
        isNocover: true,
        data: {
          name: item['name'],
          count: item['count'],
          changeable: item['changeable'],
          width: item['width'],
          height: item['height']
        }
      };
    });
  }
}));
